const FINANCIAL = 'Financial';
const DATA_INPUT = 'Data Inputs';
const EXPOSURE = 'Exposure';
const BCP_HUB = 'BCP Hub';
const RISK_HUB = 'Risk Hub';

export { FINANCIAL, DATA_INPUT, EXPOSURE, BCP_HUB, RISK_HUB };
